/** Textos da secção "kits". Chaves planas "kits.*"; "pt" é a fonte, "en" a tradução. */
const pt = {
    "kits.eyebrow": "Loja ZRS",
    "kits.title": "Kits de Compra Única",
    "kits.devBadge": "Em desenvolvimento",
    "kits.intro":
        "Pagamento único, uso imediato. Recebe o teu kit in-game logo após a confirmação do Pix.",
    "kits.oneTime": "Compra única",
    "kits.promo": "Promoção",
    "kits.buy": "Comprar",
    "kits.badgeComplete": "Completo",

    "kits.start.name": "Kit Start",
    "kits.start.desc": "Arranca forte no wipe",
    "kits.start.items": [
        "Arco + 50 flechas",
        "Machado + Picareta",
        "Roupa de couro completa",
        "500 madeira · 250 pedra",
    ],
    "kits.farm.name": "Kit Farm",
    "kits.farm.desc": "Acelera a coleta de recursos",
    "kits.farm.items": ["Jackhammer", "Chainsaw", "Large Furnace × 1", "Research Table"],
    "kits.pvp.name": "Kit PVP",
    "kits.pvp.desc": "Prepara-te para o combate",
    "kits.pvp.items": [
        "AK-47 + 120 munições",
        "Metal Facemask + Chest",
        "4 MedSyringe · 2 Bandages",
        "Granada F1 × 3",
    ],
    "kits.base.name": "Kit Base",
    "kits.base.desc": "Essencial para a primeira noite",
    "kits.base.items": [
        "Rifle semiautomático + munições",
        "Kit médico e bandagens",
        "Barricadas e saco de dormir",
        "Recursos básicos (madeira / pedra)",
    ],
    "kits.raid.name": "Kit Raid",
    "kits.raid.desc": "Ferramentas para a destruição",
    "kits.raid.items": ["C4 × 4", "Rocket × 6 + Launcher", "Satchel Charge × 8", "Explosive Ammo × 40"],
    "kits.boss.name": "Kit Boss",
    "kits.boss.desc": "O kit mais completo",
    "kits.boss.items": [
        "Tudo do Kit PVP + Raid",
        "Armor Roadsign completa",
        "Auto Turret × 1",
        "Sleeping Bag × 2",
    ],
};
const en = {
    "kits.eyebrow": "ZRS Shop",
    "kits.title": "One-Time Kits",
    "kits.devBadge": "In development",
    "kits.intro":
        "One-time payment, instant use. Get your kit in-game as soon as your Pix payment is confirmed.",
    "kits.oneTime": "One-time purchase",
    "kits.promo": "Sale",
    "kits.buy": "Buy",
    "kits.badgeComplete": "Full",

    "kits.start.name": "Start Kit",
    "kits.start.desc": "Hit the ground running on wipe day",
    "kits.start.items": [
        "Hunting Bow + 50 Wooden Arrows",
        "Hatchet + Pickaxe",
        "Full hide clothing set",
        "500 Wood · 250 Stones",
    ],
    "kits.farm.name": "Farm Kit",
    "kits.farm.desc": "Speed up your resource gathering",
    "kits.farm.items": ["Jackhammer", "Chainsaw", "Large Furnace × 1", "Research Table"],
    "kits.pvp.name": "PVP Kit",
    "kits.pvp.desc": "Gear up for the fight",
    "kits.pvp.items": [
        "AK-47 + 120 rounds",
        "Metal Facemask + Metal Chest Plate",
        "4 Medical Syringes · 2 Bandages",
        "F1 Grenade × 3",
    ],
    "kits.base.name": "Base Kit",
    "kits.base.desc": "Essentials for your first night",
    "kits.base.items": [
        "Semi-Automatic Rifle + ammo",
        "Medkit & Bandages",
        "Barricades & Sleeping Bag",
        "Basic resources (wood / stone)",
    ],
    "kits.raid.name": "Raid Kit",
    "kits.raid.desc": "Tools of destruction",
    "kits.raid.items": [
        "C4 × 4",
        "Rocket × 6 + Rocket Launcher",
        "Satchel Charge × 8",
        "Explosive 5.56 Rifle Ammo × 40",
    ],
    "kits.boss.name": "Boss Kit",
    "kits.boss.desc": "The most complete kit",
    "kits.boss.items": [
        "Everything in the PVP + Raid kits",
        "Full Road Sign armor set",
        "Auto Turret × 1",
        "Sleeping Bag × 2",
    ],
};

export default { pt, en };
